module.exports = __webpack_public_path__ + "img/goright.a43d8054.svg";